import { useEffect, useState } from 'react';
import { fetchLeaderboard } from '../services/firestore';
import AppHeader from './AppHeader';
import './Leaderboard.css';

// Registered players only, ordered by total points — anonymous profiles
// are filtered out server-side (isRegistered != true), see
// docs/auth-leaderboard-plan.md. `rank` is a cached field refreshed on a
// schedule (recomputeGlobalRanksScheduled), so it can lag a live player's
// position by up to that interval; falling back to fetch order (already
// sorted by totalPoints) keeps the list correct even when rank hasn't
// caught up yet.
function Leaderboard({ onBack }) {
  const [players, setPlayers] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    fetchLeaderboard(50)
      .then((list) => {
        if (!cancelled) setPlayers(list);
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setError('Could not load the leaderboard.');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="page">
      <div className="panel">
        <AppHeader
          subtitle="Global Leaderboard"
          topRight={<span style={{ fontSize: 20 }}>🏆</span>}
          middleItems={['Ranked by total tournament points', 'Registered players only']}
          bottomLeft="Link an account after your first tournament to appear here"
        />

        <div className="home-body single">
          <div className="home-right">
            <button className="btn-ghost" onClick={onBack}>
              ← Back
            </button>

            <div className="card leaderboard-card">
              <h3>Top Players</h3>
              {error && <p className="error">{error}</p>}
              {!error && players === null && <p className="hint">Loading…</p>}
              {players?.length === 0 && <p className="hint">No registered players yet — be the first!</p>}
              {players?.map((player, index) => (
                <div className="leaderboard-row" key={player.id}>
                  <div className="leaderboard-rank">#{player.rank ?? index + 1}</div>
                  <div className="leaderboard-name">{player.displayName || 'Player'}</div>
                  <div className="leaderboard-points">{player.totalPoints} pts</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Leaderboard;
